<template>
  <i v-if="iconFileName.indexOf('el-icon-') === 0" :class="iconFileName" />
  <svg v-else class="svg-icon" aria-hidden="true" v-on="$listeners">
    <use :xlink:href="`#icon-${iconFileName}`" />
  </svg>
</template>

<script>
  export default {
    name: 'SvgIcon',
    props: {
      iconFileName: {
        type: String,
        required: true
      }
    }
  }
</script>

<style scoped>
  .svg-icon {
    width: 20px;
    height: 20px;
    overflow: hidden;
    margin-right: 8px;
    fill: #4b4b4b;
  }
  .is-active .svg-icon {
    fill: #fff;
  }
</style>
